import * as a0 from "@grins/assets/versions" with { type: "json" }
let a0_ = "" + void a0;
import '@grins/views/layouts/partials/bonz/bonzGlobalStyles.client.css';